document.addEventListener('DOMContentLoaded', () => {
	const blocks = document.querySelectorAll(
		'.wp-block-orla-plus-animated-sentence-underline'
	);

	if (!blocks.length) return;

	const animateBlock = (block) => {
		if (block.classList.contains('is-animated')) return;

		const delay = block.dataset.delay || 700;
		const parts = block.querySelectorAll('.animated-underline');
		let index = 0;

		const run = () => {
			if (!parts[index]) {
				block.classList.add('is-animated');
				return;
			}

			parts[index].classList.add('is-active');
			index++;

			setTimeout(run, delay);
		};

		run();
	};

	/* -------- Viewport Trigger (Recommended) -------- */

	const observer = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					animateBlock(entry.target);
					observer.unobserve(entry.target);
				}
			});
		},
		{
			threshold: 0.4,
		}
	);

	blocks.forEach((block) => {
		observer.observe(block);
	});
});
